import { MetadataType } from '@aibees/elephant/hooks';
import {
  departmentLabelFormatter,
  headcountGrowthRangeLabelParser,
} from '../components/filter-tags/utils';
import {
  FilterBadgeType,
  FilterCategory,
  SearchFilterBase,
  SearchFilterType,
} from '../types';
import { departmentsOptionsForHeadcountGrowth } from './job-functions';

export default function headcountGrowthFilterConfig(): SearchFilterBase {
  return {
    name: 'Headcount Growth',
    icon: 'chart-growth',
    index: 1,
    type: SearchFilterType.ROOT,
    category: [FilterCategory.COMPANY_DATA],
    pinned: true,
    badge: FilterBadgeType.BETA,
    items: [
      {
        name: '',
        type: SearchFilterType.EMPLOYEE_BY_DEPARTMENT,
        index: 0,
        key: 'headcount_growth',
        field: 'headcount_growth',
        metadata: {
          color: 'primary',
        },
        utils: {
          tags: {
            labelFormatter: headcountGrowthRangeLabelParser,
          },
        },
        items: [
          {
            name: 'Department & Job function',
            type: SearchFilterType.CUSTOM_SELECT,
            index: 0,
            key: 'headcount_growth_department',
            field: 'headcount_growth_department',
            metadata: {
              color: 'primary',
              placeholder: 'Search Dep. & Job functions',
              preset: 'headcount_growth',
              autocomplete: {
                recent: false,
                checkboxPosition: 'left',
                multiple: false,
                customOptions: true,
              },
              styles: {
                sx: {
                  background: 'transparent',
                },
              },
              metaDataApi: {
                key: MetadataType.COMPANY_DEPARTMENT,
                enabled: false,
              },
            },
            utils: {
              tags: {
                labelFormatter: departmentLabelFormatter,
              },
            },
            config: { labelKey: 'label', valueKey: 'value' },
            nested: true,
            treeOptions: departmentsOptionsForHeadcountGrowth,
          },
          {
            name: 'Employee Growth (%)',
            type: SearchFilterType.NUMBER_RANGE,
            index: 1,
            key: 'headcount_growth_number',
            field: 'headcount_growth_number',
            metadata: {
              color: 'primary',
              styles: {
                sx: {
                  '.MuiCardHeader-root': {
                    paddingTop: 0,
                  },
                },
              },
              isPercent: true,
              numberRange: {
                min: -Infinity,
                acceptNegative: true,
              },
            },
            open: true,
            nested: false,
          },
          {
            name: 'Time Frame',
            type: SearchFilterType.TIME_FRAME,
            index: 0,
            key: 'headcount_growth_timeframe',
            field: 'headcount_growth_timeframe',
            metadata: {
              color: 'primary',
              placeholder: '',
              styles: {
                sx: {
                  padding: 0,
                  border: 0,
                  ':hover': {
                    border: 0,
                  },
                },
              },
              autocomplete: { recent: false, dontFilterOptions: true },
              delimiter: ':',
              singleEntry: false,
            },
            config: { labelKey: 'label', valueKey: 'value' },
            nested: false,
          },
        ],
      },
    ],
  };
}
